import React, { Component } from 'react'
import { firebaseAuth, firebaseDb } from '../../lib/firebase'
import { Link } from 'react-router-dom'
import { Appbar, Button, Container } from 'muicss/react'
import { RaisedButton } from 'material-ui';

import Debug from 'debug'
const debug = Debug('app:components:Test')

const GoogleAuthButton = (props) => (
  <Button color="danger" onClick={() => {
    var provider = firebaseAuth.GoogleAuthProvider()
    firebaseAuth.signInWithRedirect(provider).then((result) => {
      debug("result:" + result)
      this.setState({
        currentUser: {
          id: result.user.id,
          screenName: result.user,
          token: result.credential.accessToken
        }
      })
    }).catch((error) => {
      debug("error: " + error)
    })
  }}>
    GoodleIDでログイン
  </Button>
)

const TwitterAuthButton = (props) => (
  <Button color="primary" onClick={() => {
    var provider = firebaseAuth.TwitterAuthProvider();
    provider.setCustomParameters({
      'lang': 'jp'
    });
    firebaseAuth.signInWithRedirect(provider).then((result) => {
      this.setState({
        currentUser: {
          id: result.user.id,
          screenName: result.result.additionalUserInfo.profile.id_str,
          token: result.credential.accessToken,
          secret: result.credential.secret
        }
      })
    }).catch((error) => {
      debug("error: " + error)
    })
  }}>
    Twitterでログイン
  </Button>
)

const DownloadLink = (props) => (
  (this.state.product && (
    <a href={this.state.product.url} donwload={this.state.product.title}>Download</a>
  ))
)

export class Test extends Component {
  constructor(props) {
    super(props)

    // 初期化
    this.state = {
      currentUser: null,
      product: null
    }
  }

  render() {
    if(this.state.currentUser) {
      if (this.state.product) {
        return (
          <div>
            <DownloadLink />
          </div>
        )
      } else {
        return (
          <RaisedButton title="C93" />
        )
      }
    } else {
      return (
        <div>
          <GoogleAuthButton />
          <TwitterAuthButton />
        </div>
      )
    }
  }
}

export default Test



// WEBPACK FOOTER //
// ./src/components/Test/index.js